
import React, { useEffect, useState } from 'react';
import { OrgDiagram } from 'basicprimitivesreact';
import { LCA, Tree, Colors, PageFitMode, Enabled, OrientationType, Size, TemplateConfig, AnnotationType, ChildrenPlacementType, Visibility, ShapeType, Thickness, LineType, OrgItemConfig } from 'basicprimitives';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  Dialog, Button, DialogActions, DialogContent, Avatar, AppBar, Grid, Switch, IconButton, ButtonGroup, Toolbar,
  Tooltip, Badge, Link
} from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { fetchChartData2 } from "../../../redux/actions/structure.actions";
import { axiosFetch } from '../../../utils/AxiosFetch';
import { useNavigate } from "react-router";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from "@mui/material/styles";
import AddUserModal from "../../../shared/AddUserModal";
import ChangeTeamModal from "../MyAccount/ChangeTeamModal";
import ThreePIcon from '@mui/icons-material/ThreeP';
import { OrgDiagramPdfkit } from 'basicprimitives';
import CloseIcon from '@mui/icons-material/Close';
import html2canvas from 'html2canvas';
import blobStream from 'blob-stream';
import jsPDF from 'jspdf';
import PDFDocument from 'pdfkit-nodejs-webpack';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 15,
  height: 15,
  border: `1px solid ${theme.palette.background.paper}`,
  backgroundColor: "#113776 !important",
  fontSize: 1,
  color: 'white'
}));

function OrgChart() {
  const navigate = useNavigate();
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
  const dispatch = useDispatch();
  const [items, setItems] = useState([])
  const [cursorItem, setCursorItem] = useState(isUserLogged.userid)
  const [allUser, setAllUser] = useState(isUserLogged.userid)

  const [openReprt, setOpenReprt] = React.useState(false);
  const [isPopupOpen, setisPopupOpen] = useState(false);
  const [deptName, setDeptName] = useState("");
  const [teamName, setTeamName] = useState("");
  const [reprtMngrId, setReptrMngrId] = useState("");
  const [repManagerName, setRepManagerName] = useState("")
  const [org, setOrg] = useState([]);
  const [orgCount, setOrgCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [url, setUrl] = React.useState(null);
  let chartData = useSelector(state => state.orgStructure_Reducer.orgStructureList)


  const handleTeamMembers = (item) => {

    if (isPopupOpen) {
      setisPopupOpen(false);
    } else {
      setDeptName(item.departmentName)
      setTeamName(item.teamName)
      setReptrMngrId(item.id)
      setRepManagerName(item.title)
      setisPopupOpen(true);
    }
  };


  const handleReportingPopup = (e) => {

    if (openReprt) {
      setOpenReprt(false);

    }
    else {
      setOpenReprt(true);
      items.filter((data) => {
        if (e.id === data.id) {
          setOrg(data)
        }
      })
      setOrgCount(e.teamCount);
    }
  };
  useEffect(() => {
    setItems(chartData)
  }, [chartData])

  useEffect(() => {
    dispatch(fetchChartData2(allUser))

    // fetchData()
  }, [allUser])
  useEffect(() => {
    dispatch(fetchChartData2(allUser))
    // fetchData()
  }, [])
  const fetchData = () => {
    axiosFetch({
      method: 'GET',
      url: `/employees/structure/demo/${allUser}`,

    })
      .then((res) => {
        if (res.status === 200) {
          setItems(res.data)
        }
        if (res.status === 401) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        if (res.status === 401) {
          navigate("/")
        }

      })
      .catch(error => {
        console.log(error);
      });
  }

  function NodeDragDropSource({ itemConfig, canDropItem, onDropItem }) {
    const [{ isDragging }, drag] = useDrag({
      type: "account",
      id: itemConfig.id,
      end: (item, monitor) => {
        const dropResult = monitor.getDropResult();
        if (item && dropResult) {
          console.log(itemConfig, dropResult)

        }
      },

      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1
      })
    })
    const opacity = isDragging ? 0.4 : 1;

    const [{ isOver, canDrop }, drop] = useDrop({
      accept: "account",
      drop: () => ({
        data: itemConfig
        //   const didDrop = monitor.didDrop();
        // //   console.log(didDrop,itemConfig)
        //   if (didDrop && itemConfig.id === itemConfig.id) {
        //       return;
        //   }
        //   onDropItem(itemConfig.id, item.id);
      }),
      //   canDrop(item, monitor) {
      //       return canDropItem(itemConfig.id, item.id);
      //   },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
      }),
    })

    let itemTitleColor = itemConfig.itemTitleColor != null ? itemConfig.itemTitleColor : "#113776";
    if (isOver) {
      if (canDrop) {
        itemTitleColor = "green";
      } else {
        itemTitleColor = "red";
      }
    }

    return (
      <div className='org-box' ref={drop}  >
        <div ref={drag} className="ContactTemplate" style={{ backgroundColor: "#E4EEFF", opacity, border: "1px solid grey", borderRadius: 10, height: "auto", padding: "3px" }}>
          <div style={{ backgroundColor: "#113776", textAlign: "center", borderRadius: 5, color: "white", fontWeight: "600" }}>{itemConfig.title}</div>
          <Grid container sx={{ padding: "5px", minHeight: "60px", display: "flex", alignItems: "center" }}>
            <Grid item xs={4}>
              <Badge
                overlap="circular"                
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={itemConfig.teamCount > 0 ? <SmallAvatar className='org-count'>{itemConfig.teamCount}</SmallAvatar> : <></>}>
                <Avatar
                  // sx={{
                  //     width:50,
                  //     height:50
                  // }}
                  src={`/api/uploads/image/show/${itemConfig.image}`}
                  alt={itemConfig.title}
                  sx={{ backgroundColor: "#113776", marginRight: "10px" }} />
              </Badge>
            </Grid>
            <Grid item xs={8}>
              <div style={{ wordBreak: "break-word" }}>{itemConfig.description}</div>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }

  const Chart = () => {
    var arr = [];
    items.map((list) => {
      arr.push(new OrgItemConfig(
        {
          "id": list.id,
          "parent": list.parent,
          "title": list.firstName + " " + list.lastName,
          "description": list.jobTitleName,
          "image": list.profilePhotoName,
          "groupTitle": list.empNumber === 0 ? "CEO" : list.departmentCode,
          "teamName": list.teamName,
          "departmentName": list.departmentName,
          "departmentId": list.departmentId,
          "reportingPersonId": list.parent,
          "isManager": list.isManager,
          "teamCount": list.teamCount,
          childrenPlacementType: list.empNumber === 0 ? ChildrenPlacementType.Horizontal : ChildrenPlacementType.Vertical,
          leavesPlacementType: ChildrenPlacementType.Horizontal,
          groupTitleColor: "#113776",
          hasButtons: list.parent === allUser ? Enabled.True : list.id === allUser ? Enabled.True : Enabled.False,
          // hasButtons: Enabled.True

        }
      ));

    })
    const handleView = (data) => {
      if (data != null) {
        navigate(`/users-profile/${data.id}`);
      }
    };
    const configDef = {
      pageFitMode: PageFitMode.FitToPage,
      // autoSizeMinimum: { width: 100, height: 100 },
      cursorItem: cursorItem,
      highlightItem: 0,
      hasSelectorCheckbox: Enabled.False,
      items: arr,
      minimumVisibleLevels: 10,
      dotItemsInterval: 1,
      minimalVisibility: Visibility.Dot,
      minimizedItemShapeType: ShapeType.Dot,
      normalLevelShift: 20,
      dotLevelShift: 20,
      lineLevelShift: 10,
      normalItemsInterval: 10,
      dotItemsInterval: 10,
      lineItemsInterval: 4,
      defaultTemplateName: "contactTemplate",
      templates: [{
        name: "contactTemplate",
        itemSize: { width: 210, height: 87 },
        minimizedItemSize: new Size({ width: 14, height: 14 }),
        highlightPadding: { left: 2, top: 2, right: 2, bottom: 2 },
        onItemRender: ({ context: itemConfig }) => {
          return <NodeDragDropSource
            itemConfig={itemConfig}
          />;
        },
        onHighlightRender: ({ context: itemConfig }) => {
          return <div style={{ borderColor: itemConfig.itemTitleColor }}>
            <div style={{ width: 100, height: 100 }} >
              <div style={{ backgroundColor: itemConfig.itemTitleColor }}>
                {itemConfig.childrencount}
              </div>
            </div>
          </div>
        },
        onButtonsRender: (({ context: itemConfig }) => {
          return (
            isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" ?
              <ButtonGroup orientation="vertical" size="small" variant="text">
                <Tooltip title="Add Team Members" placement="right-end">
                  <IconButton sx={{ color: "#113776" }} size="small" onClick={() => handleTeamMembers(itemConfig)}>
                    <PersonAddIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
                {itemConfig.parent !== null ? <Tooltip title="Change team" placement="right-end">
                  <IconButton sx={{ color: "#113776" }} size="small" onClick={() => handleReportingPopup(itemConfig)}>
                    <SwapHorizontalCircleIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip> : <></>}
                <Tooltip title="View Details" placement="right-end">
                  <IconButton sx={{ color: "#113776" }} size="small" color="primary" onClick={() => handleView(itemConfig)}>
                    <ThreePIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </ButtonGroup>
              : <></>
          )
        }),
      }]
    };

    let [config, setConfig] = useState(configDef);

    const onCursorChanged = (e, { context: data }) => {
      let annotations = [
        {
          annotationType: AnnotationType.HighlightPath,
          items: [data.id, items[0].id],
          color: Colors.Navy,
          lineWidth: 5,
          opacity: 0.8,
          showArrows: false
        }
      ];

      setConfig({
        ...config,
        cursorItem: data.id,
        highlightItem: data.id,
        annotations
      });
    };
    const handleonCursorChanging = (event, data) => {
      const { context: item } = data;
      setCursorItem(item.id)
      if (item != null) {
        setAllUser(item.id)
      }
    };
    const handlePdf = () => {
      const orgDiagramPlugin = OrgDiagramPdfkit({
        ...config,
        items,
        cursorItem: null,
        hasSelectorCheckbox: Enabled.False,
        templates: [{
          name: "contactTemplate",
          itemSize: { width: 200, height: 87 },
          minimizedItemSize: new Size({ width: 14, height: 14 }),
          highlightPadding: { left: 2, top: 2, right: 2, bottom: 2 },
          onItemRender: ({ context: itemConfig }) => {
            return <NodeDragDropSource
              itemConfig={itemConfig}
            />;
          },
          onHighlightRender: ({ context: itemConfig }) => {
            return <div style={{ borderColor: itemConfig.itemTitleColor }}>
              <div >
                <div style={{ backgroundColor: itemConfig.itemTitleColor }}>
                  {itemConfig.childrencount}
                </div>
              </div>
            </div>
          },
          onButtonsRender: (({ context: itemConfig }) => {
            return (
              isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR" ?
                <ButtonGroup orientation="vertical" size="small" variant="text">
                  <Tooltip title="Add Team Members" placement="right-end">
                    <IconButton sx={{ color: "#113776" }} size="small" onClick={() => handleTeamMembers(itemConfig)}>
                      <PersonAddIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                  {itemConfig.parent !== null ? <Tooltip title="Change team" placement="right-end">
                    <IconButton sx={{ color: "#113776" }} size="small" onClick={() => handleReportingPopup(itemConfig)}>
                      <SwapHorizontalCircleIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip> : <></>}
                  <Tooltip title="View Details" placement="right-end">
                    <IconButton sx={{ color: "#113776" }} size="small" color="primary" onClick={() => handleView(itemConfig)}>
                      <ThreePIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </ButtonGroup>
                : <></>
            )
          }),
        }]
      });

      var diagramSize = orgDiagramPlugin.getSize();


      var doc = new PDFDocument({ size: [diagramSize.width + 100, diagramSize.height + 150], bufferPages: true });
      var stream = doc.pipe(blobStream());

      doc.save();


      orgDiagramPlugin.draw(doc, 50, 100);

      doc.restore();

      doc.end();

      stream.on('finish', function () {
        const blob = stream.toBlobURL('application/pdf');
        setUrl(blob);
      });

      // setIsVisible(true)

    }
    return <div style={{ width: "100%", height: "100%" }}>
      {/* <Button className = theme-btn onClick={() => handlePdf()}>Download PDF</Button> */}
      <OrgDiagram centerOnCursor={true} config={config}
        onCursorChanging={handleonCursorChanging}
      // onCursorChanged={onCursorChanged}
      />
    </div>
  }

  const onClose = () => {
    setIsVisible(false)
  }
  return (
    <div  >
      <div id="container" className="App organizational-structure" style={{ height: "79vh" }}>
        <DndProvider backend={HTML5Backend}>
          <Chart />
        </DndProvider>
      </div>
      <AddUserModal openModal={isPopupOpen} addUser={handleTeamMembers} teamName={teamName} departmentName={deptName} reportingManagerId={reprtMngrId.toString()} reportingManagerName={repManagerName} />
      <ChangeTeamModal open={openReprt} handleClick={handleReportingPopup} pageData={org} count={orgCount} />

      {isVisible ? (
        <Dialog fullScreen open={isVisible} onClose={onClose}>
          <AppBar style={{ position: 'relative' }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                <CloseIcon />
              </IconButton>

            </Toolbar>
          </AppBar>
          <DialogContent>
            <div style={{ width: "100%", height: "100%" }}>
              <iframe title="placeholder" src={url} style={{ width: "100%", height: "100%", border: "none" }} />
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={onClose}>Close</Button>
          </DialogActions>
        </Dialog>
      ) : <></>}
    </div>
  )
}
export default OrgChart;